import { render, staticRenderFns } from "./Introduction.vue?vue&type=template&id=1aa229e6&scoped=true"
import script from "./Introduction.vue?vue&type=script&lang=js"
export * from "./Introduction.vue?vue&type=script&lang=js"
import style0 from "./Introduction.vue?vue&type=style&index=0&id=1aa229e6&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa229e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aa229e6')) {
      api.createRecord('1aa229e6', component.options)
    } else {
      api.reload('1aa229e6', component.options)
    }
    module.hot.accept("./Introduction.vue?vue&type=template&id=1aa229e6&scoped=true", function () {
      api.rerender('1aa229e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/self-select-stock/components/Introduction.vue"
export default component.exports